import React, { FC } from 'react';


import GradientText  from '../Gradients/GradientText';
import { Body1Bold } from '../../config/designSystem/typography';
import { COLORS, GRADIENTS, Gradient } from '../../config/designSystem/Colors';
import { GradientView } from '../Gradients/GradientView';
import { NavigationIcon } from './NavigationIcon';
import { SPACING } from '../../config/designSystem/Spacing';
import { TouchableOpacity, View } from 'react-native';
import { useDrawerLabel, userDrawerLabelPropsKey } from '../../hooks/navigation/useDrawerLabel';
import { useNavigationOnPress } from '../../hooks/navigation/useNavigationOnPress';

export interface NavigationPanelTabElementProp {
    labelKey: userDrawerLabelPropsKey;
    selected: boolean;
  }



const NavigationPanelTabElement: FC<NavigationPanelTabElementProp> = ({labelKey, selected}) => {

  const label =  useDrawerLabel(labelKey);

  const {onPress} = useNavigationOnPress(labelKey);

  const renderText = () => {
    if(!selected) return <GradientText gradient={GRADIENTS.brand['primary-light'] as Gradient} label={label} typo={'Body1Bold'}/>;
    return <Body1Bold color={COLORS.content['inverse-primary']}>{label}</Body1Bold>;
  };

  const renderTabWithoutBackground = () => {
    return(<View style={{
      flexDirection:'row',
      paddingHorizontal:SPACING['sp-16'],
      paddingVertical: SPACING['sp-4'],
      columnGap:SPACING['sp-12'],
      alignItems:'center',
    }}>
      <NavigationIcon labelKey={labelKey} selected={selected} size={32}/>
      {renderText()}
    </View> );
  };

  const renderTabWithBackground = () => {
    if(selected) {
      return(
        <GradientView gradient={GRADIENTS.brand['primary-light'] as Gradient} style={{borderRadius: SPACING['sp-12']}}>
          {renderTabWithoutBackground()}
        </GradientView>
      );
    } else {
      return (
        <>
          {renderTabWithoutBackground()}
        </>);
    }
  };




  return(
    <TouchableOpacity onPress={onPress} >
      {renderTabWithBackground()}
    </TouchableOpacity>
  );
};



export default NavigationPanelTabElement;